// Dependencies
import DiplomasSlider from 'slider';


class Diplomas {
  /**
   * Constructor: Hero Constructor.
   */
  constructor(options = {}) {
    // Context
    this._context = options.context || document;

    // Root
    this._root = this._context.querySelector('[type="diplomas"]');
    
    // Elements
    this._cards = [...this._root.querySelectorAll('.diploma-card')];
    this._grid  = this._root.querySelector('.diplomas__grid');
    this._nav   = this._root.querySelector('.diplomas__nav');
    this._prev  = this._root.querySelector('.diplomas__prev');
    this._next  = this._root.querySelector('.diplomas__next');

    // Slider Class
    this.Slider = new DiplomasSlider({
      root   : this._root,
      grid   : this._grid,
      nodes  : this._cards,
      nav    : this._nav,
      buttons: {
        prev: this._prev,
        next: this._next,
      },
    });
  }


  /**
   * Resize: Resize the Cases.
   */
  resize() {
    this.Slider.resize();
  }
}

export default Diplomas;


// WEBPACK FOOTER //
// ./src/js/layouts/diplomas/index.js